import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

type DeleteDirectoryMutationArgs = {
  directoryPaths: string[];
  datasetId: string;
};

export function useDeleteDirectoryMutation(): UseMutationResult<
  void,
  unknown,
  DeleteDirectoryMutationArgs
> {
  const { files: fileService } = useDomainServices();
  return useMutation<void, unknown, DeleteDirectoryMutationArgs>({
    mutationFn: ({ directoryPaths, datasetId }) => {
      return fileService.deleteDirectories(datasetId, directoryPaths);
    },
  });
}
